import { vTooltip } from 'floating-vue'

// v-tooltip: Displays a popover on hovered element.
//
// NOTE: we're using this middleware directive instead of importing
// floating-vue directly so it's easier to switch to a different library if we
// need it in the future.
export default vTooltip
